import React from 'react';
import PropTypes from 'prop-types';
import {Alert, Button, Modal} from 'react-bootstrap';
import Loader from 'react-loader-spinner';

class SendBreakdownEmails extends React.Component {

  constructor(props) {
    super(props);
  };

  handleSendBreakdownEmails = () => {
    const chitIds = Object.keys(this.props.idsOfSelectedChitsCrossedByFiltered);
    this.props.sendBreakdownEmailsRequest(chitIds, this.props.productionId, this.props.productionDate);
  };

  render = () => {
    const modalBackdrop = this.props.bulkActionsRunning ? 'static' : true;
    return (
      <Modal show={true} onHide={this.props.showHideBulkActionsSendBreakdownEmailsWindow.bind(this, false)} keyboard={!this.props.bulkActionsRunning} backdrop={modalBackdrop}>
        <Modal.Header closeButton={!this.props.bulkActionsRunning}>
          <Modal.Title>Send breakdown emails</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Alert variant='warning'>
            Are you sure you want to send breakdown emails to selected chits?
          </Alert>
        </Modal.Body>
        <Modal.Footer>
          {this.props.bulkActionsRunning &&
          <Loader type="ThreeDots" color="#2BAD60" height={50} width={50}/>
          }
          <Button variant="default" onClick={this.props.showHideBulkActionsSendBreakdownEmailsWindow.bind(this, false)} disabled={this.props.bulkActionsRunning}>
            Cancel
          </Button>
          <Button variant="primary" onClick={this.handleSendBreakdownEmails} disabled={this.props.bulkActionsRunning}>
            Yes
          </Button>
        </Modal.Footer>
      </Modal>
    )
  }
}

SendBreakdownEmails.propTypes = {
  idsOfSelectedChitsCrossedByFiltered: PropTypes.object.isRequired,
  filteredChitRecordsByChitId: PropTypes.object.isRequired,
  productionId: PropTypes.number.isRequired,
  productionDate: PropTypes.string.isRequired,
  showHideBulkActionsSendBreakdownEmailsWindow: PropTypes.func.isRequired,
  sendBreakdownEmailsRequest: PropTypes.func.isRequired,
  bulkActionsRunning: PropTypes.bool.isRequired
};

export default SendBreakdownEmails;